__turbopack_context__.v({
  "socialAnchor": "rt6c1q_socialAnchor",
});
